import { render, staticRenderFns } from "./ShortSection.vue?vue&type=template&id=13077158&scoped=true"
import script from "./ShortSection.vue?vue&type=script&lang=js"
export * from "./ShortSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13077158",
  null
  
)

export default component.exports